import React from 'react';
import { Typography } from 'seagull';
import styles from "../ServicesSection.module.scss";
import OngoingServiceSwitch from "./OngoingServiceSwitch";
import { RecurrencePeriodTypes } from "../../../../../models/service/model";
import { serviceModel } from "../../../../../models";
import { dayOfMonthBullet, dayOfWeekBiWeeklyBullet, dayOfWeekWeeklyBullet } from "../../../../../utils/service-description";
import { BillingTriggerType } from "../../../../../types/api.model";
export default function AutomaticServiceBillingItem(props) {
  const {
    serviceName,
    serviceId,
    costDisplay,
    billing,
    idx,
    agreement,
    disabled,
    tooltipTitle,
    onRefresh
  } = props;
  const billingDayOfWeek = serviceModel.billingDayOfWeek({
    billing
  });
  const billingDayOfMonth = serviceModel.billingDayOfMonth({
    billing
  });
  const recurrencePeriod = billing.trigger === BillingTriggerType.Ongoing && serviceModel.recurrencePeriod(billing);
  const billingPeriodLabel = recurrencePeriod === RecurrencePeriodTypes.Weekly && billingDayOfWeek && dayOfWeekWeeklyBullet(billingDayOfWeek) || recurrencePeriod === RecurrencePeriodTypes.BiWeekly && billingDayOfWeek && dayOfWeekBiWeeklyBullet(billingDayOfWeek) || recurrencePeriod === RecurrencePeriodTypes.Monthly && billingDayOfMonth && dayOfMonthBullet(billingDayOfMonth, recurrencePeriod) || recurrencePeriod && recurrencePeriod !== RecurrencePeriodTypes.Monthly && recurrencePeriod !== RecurrencePeriodTypes.Weekly && recurrencePeriod !== RecurrencePeriodTypes.BiWeekly && dayOfMonthBullet(serviceModel.isBilledUpfront({
    billing
  }) ? 1 : 'last', recurrencePeriod);
  return /*#__PURE__*/React.createElement("li", {
    "data-testid": "service-".concat(idx),
    className: styles.serviceBox
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.serviceDescription
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "name"
  }, serviceName), /*#__PURE__*/React.createElement(Typography, {
    className: styles.cost,
    noWrap: true,
    variant: "paragraph2",
    skin: "secondary"
  }, /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "cost",
    variant: "paragraph2",
    skin: "secondary"
  }, costDisplay), billingPeriodLabel && /*#__PURE__*/React.createElement(Typography, {
    noWrap: true,
    "data-testid": "billing",
    variant: "paragraph2",
    skin: "secondary"
  }, billingPeriodLabel.text))), /*#__PURE__*/React.createElement("div", {
    className: styles.lineItemAction
  }, /*#__PURE__*/React.createElement(OngoingServiceSwitch, {
    "data-testid": "billing-control-service-".concat(idx, "-switch"),
    agreementId: agreement.id,
    serviceId: serviceId,
    serviceName: serviceName,
    isPaused: serviceModel.isPaused({
      billing
    }),
    isDisabled: disabled,
    tooltipTitle: tooltipTitle,
    onRefresh: onRefresh
  })));
}